import React, { createRef } from 'react';
import TopBar from './components/TopBar';
import StreamWebcam from './components/StreamWebcam';
import Container from '@material-ui/core/Container';
import {
  Grid,
  Button,
  TextField,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
  CircularProgress
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

import dayjs from 'dayjs';
import axios from 'axios';

const STATUS_IDLE = 0
const STATUS_UPLOADING = 1
export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      Images: [],
      Image: "",
      status: STATUS_IDLE,
      openImage: false,
      ref: createRef(),
      isLoading: false,
      TypeArr: [
        { 'value': '-1', 'label': '--Vui lòng chọn loại' },
        { 'value': '0', 'label': 'Detection' },
        { 'value': '1', 'label': 'Classify' }
      ],
      TypeValue: { 'value': '-1', 'label': '--Vui lòng chọn loại' },
      patientID: "",
      patientName: "",
      sampleID: "",
      collectionDate: dayjs(new Date()),
      entries: [],
      labels: ['Mama cow', 'Baby cow']
    }
  }


  uploadFiles = async (data) => {
    const {
      TypeValue
    } = this.state
    this.setState({
      status: STATUS_UPLOADING,
      isLoading: true
    });

    // console.log(URL.createObjectURL(chosenFile[0]))
    let url =  "" 
    if (TypeValue['label'] === 'Detection') {
      url = "https://sperms.ailab.vn:5003/upload"
    } else {
      url = "https://sperms.ailab.vn:5004/upload"
    }


    await new Promise(async (resolve) => {
      // await data.forEach(async (file, index, array) => {
      //   console.log(file)
      // })
      await axios({
        method: "POST",
        url: url,
        data: data,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        // resolve(res)
        // console.log(res)
        // this.state.ref.current.files = null
        this.setState({
          Images: res.data,
          files: [],
          status: STATUS_IDLE,          
          isLoading: false,
        })
      })
    }).then((result) => {
      // console.log(result)
    })


  }

  renderFileList() {
    return <ol>
      {[...this.state.files].map((f, i) => (
        <li key={i}>{f.name}</li>
      ))}
    </ol>
  }

  renderButtonStatus() {
    return (this.state.status === STATUS_IDLE) ?
      'Submit to Analysis' :
      <Grid item>
        <CircularProgress aria-label="progress" />
      </Grid>
  }

  packFiles = async (files) => {
    const data = new FormData();

    [...files].forEach((file, i) => {
      data.append(`files`, file)
    })
    return data
  }

  handleUploadClick = async () => {    
    const {
      TypeValue
    } = this.state
    let err = 0
    if (TypeValue['value'] === '-1') {
      err = 1
      alert('Vui lòng chọn loại phân tích')
    }

    else if (!this.state.files.length) {
      err = 2
      alert('Vui lòng upload hình ảnh')
    }

    if (err === 0) {

      const data = await this.packFiles(this.state.files)
      this.uploadFiles(data)

    }

  }

  saveTypeChanges = (value) => {
    this.setState({
      // TypeArr: value === null ? [{ 'value': '-1', 'label': '--Vui lòng chọn loại' }] : value,
      TypeValue: value === null ? { 'value': '-1', 'label': '--Vui lòng chọn loại' } : value,
    }, () => { })
  }

  render() {
    const {
      patientID,
      patientName,
      sampleID,
      collectionDate,
      openImage,
      Image
    } = this.state;

    return (
      <div className="App">
        <header className="App-header">
          <TopBar name="Online Sperms Analysis" />
          <Container maxWidth="xl" className="px-4 md:px-6 lg:px-8">
            <Card className="w-full">
              <CardContent className="p-4 md:p-6">
                {/* Form Grid - Responsive layout */}
                <Grid container spacing={2}>
                  {/* Patient ID - Full width on mobile, quarter width on larger screens */}
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="Mã bệnh nhân"
                      error={patientID === ""}
                      value={patientID}
                      name="PatientID"
                      id="PatientID"
                      onChange={(e) => {
                        this.setState({
                          patientID: e.target.value
                        });
                      }}
                      required
                      helperText={patientID === "" ? 'Chưa nhập mã Bệnh nhân.' : null}
                      size="medium"
                    />
                  </Grid>

                  {/* Patient Name */}
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="Tên bệnh nhân"
                      value={patientName}
                      error={patientName === ""}
                      name="PatientName"
                      id="PatientName"
                      onChange={(e) => {
                        this.setState({
                          patientName: e.target.value
                        });
                      }}
                      required
                      helperText={patientName === "" ? 'Chưa nhập tên Bệnh nhân.' : null}
                      size="medium"
                    />
                  </Grid>

                  {/* Sample ID */}
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      error={sampleID === ""}
                      label="Mã mẫu phân tích"
                      value={sampleID}
                      name="SampleID"
                      id="SampleID"
                      onChange={(e) => {
                        this.setState({
                          sampleID: e.target.value
                        });
                      }}
                      required
                      helperText={sampleID === "" ? 'Chưa nhập mã Mẫu phân tích.' : null}
                      size="medium"
                    />
                  </Grid>

                  {/* Date Picker */}
                  <Grid item xs={12} sm={6} md={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        label="Ngày lấy mẫu"
                        inputFormat="DD/MM/YYYY"
                        value={collectionDate}
                        onChange={(date) => {
                          this.setState({
                            collectionDate: date
                          });
                        }}
                        renderInput={(params) => <TextField {...params} fullWidth size="medium" />}
                      />
                    </LocalizationProvider>
                  </Grid>

                  {/* StreamWebcam Component - Full width */}
                  <Grid item xs={12}>
                    <StreamWebcam
                      patientID={patientID}
                      patientName={patientName}
                      sampleID={sampleID}
                      collectionDate={collectionDate}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            {/* Responsive Dialog */}
            <Dialog
              fullWidth={true}
              maxWidth="lg"
              open={openImage}
              onClose={() => { this.setState({ openImage: false }); }}
              aria-labelledby="form-dialog-title"
            >
              {openImage && (
                <>
                  <DialogTitle id="form-dialog-title">Image</DialogTitle>
                  <DialogContent>
                    <Stack spacing={2}>
                      <DialogContentText>
                        <Typography variant="body2" component="span">
                          <Button variant="text">
                            {Image}
                          </Button>
                        </Typography>
                      </DialogContentText>
                      <div className="w-full overflow-auto">
                        <img
                          className="w-full max-w-full h-auto"
                          alt={Image}
                          src={'https://sperms.ailab.vn:5003/image?file_path=' + Image}
                        />
                      </div>
                    </Stack>
                  </DialogContent>
                  <DialogActions className="p-4">
                    <Button
                      onClick={() => { this.setState({ openImage: false }); }}
                      color="secondary"
                    >
                      Cancel
                    </Button>
                  </DialogActions>
                </>
              )}
            </Dialog>
          </Container>
        </header>
      </div>
    );
  }
}